import { Injectable } from "@angular/core";
import { HttpService } from "@planard/@core/backend/api/http.service";
import { Observable } from "rxjs";
import { Plan } from "@planard/@core/entities/plan";

@Injectable()
export class PlanApi {
  private readonly apiController: string = "costplan";

  constructor(private api: HttpService) {}

  listPrices<T>(
    scenarioId: number,
    approveRequestId?: number
  ): Observable<any> {
    const endpointUrl = approveRequestId
      ? `${this.apiController}/listPrices/${scenarioId}/?approveRequestId=${approveRequestId}`
      : `${this.apiController}/listPrices/${scenarioId}`;
    return this.api.get(endpointUrl);
  }

  costTrend<T>(data: any): Observable<any> {
    return this.api.post(`${this.apiController}/CostTrendReport`, data);
  }

  costOverview<T>(data: any): Observable<any> {
    return this.api.post(`${this.apiController}/CostOverviewReport`, data);
  }

  update<T>(plan: Plan): Observable<any> {
    return this.api.post(`${this.apiController}/update`, plan);
  }

  listApproverUsersSubDepartments<T>(): Observable<any> {
    return this.api.get(
      `${this.apiController}/listApproverUsersSubDepartments`
    );
  }
}
